import React from 'react';
import styled from 'styled-components';
const IframeWrapper = styled.div `
  display: ${props => (props.hideIframe ? 'none' : 'block')};
  iframe {
    width: 100%;
    ${props => (props.adjustWidth ? 'max-width: 750px' : '')}
  }
`;
const SecurityBlanket = styled.div `
  position: absolute;
  background: #FAFAFA;
  height: ${p => (p.zeroHeight === true ? '0' : '100%')};
  width: 100%;
  display: ${p => (p.hideIframe ? 'block' : 'none')};
`;
const IframePaymentContainer = ({ hideIframe, children, adjustWidth = false }) => React.createElement(React.Fragment, null,
    React.createElement(SecurityBlanket, { hideIframe: hideIframe, zeroHeight: hideIframe }),
    React.createElement(IframeWrapper, { hideIframe: hideIframe, adjustWidth: adjustWidth },
        React.createElement("iframe", { id: 'cybersource-page', name: 'cybersource-page', title: 'Credit Card Fields', height: '1150' }),
        children));
export default IframePaymentContainer;
